import { Component } from "react";
import CabPage from "../CabPage.js";
import Table from 'react-bootstrap/Table';
import axios from "axios";
import Alert from 'react-bootstrap/Alert';
import { FormataValor, FormataData, Separador } from "../k_functions.js";

function TopTabRelVen(k)
{
  return (
    <thead key={3*k+1}>
      <tr key={k}>
        <th width="10%">Data</th>
        <th width="35%">Produto</th>
        <th width="25%">Unid</th>
        <th width="10%">Q&nbsp;Ven<br/>Q&nbsp;Bon</th>
        <th width="10%">$Unit</th>
        <th width="10%">$Total</th>
      </tr>
    </thead>
  )
}

class VendasRelFechRes extends Component {
  state = {
    aVendasCli: [], // total de vendas por cliente
    aVendasCPU: [], // total de vendas por cliente, produto e unidade
    aVendasDPU: [], // total de vendas por dia, produto e unidade - 17/09/25
    aVendasTot: [], // total de vendas conforme filtros selecionados

    aPenAteHoj: [], // pendencias até a data de hoje
    aTotPeAHoj: [], // total de pendencias ate hoje

    aParPaVePe: [], // parcelas pagas das vendas do período
    aTotPaVePe: [], // total de parcelas pagas das vendas do período

    aPenDatFut: [], // pendencias data futura
    aTotPeDFut: [], // total de pendencias futuras
  };

  /* requisição com axios para ler lista de vendas */
  async componentDidMount() {
//    console.log(this.props);
    axios({
      method: 'get',
      url: `${process.env.REACT_APP_API}TrataGetPost.php`,
      params: {
        prog_trata: "./Vendas/VendasRelat.php",
        func_trata: "VendasRelat",
        dat_ini: this.props.dIni,
        dat_fim: this.props.dFim,
        cod_pro: this.props.cPro,
        cod_cli: this.props.cCli,
      }
    })
    .then((response) => {
      //alert(response.data);
//      console.log(response.data);
      this.setState({ aVendasCli: response.data[0] });
      this.setState({ aVendasCPU: response.data[2] });
      this.setState({ aVendasDPU: response.data[4] });  // 17/09/25
      this.setState({ aVendasTot: response.data[6] });
      this.setState({ aPenAteHoj: response.data[7] });
      if (this.props.cPMA === "S")
        this.setState({ aTotPeAHoj: response.data[8] });
      else
        this.setState({ aTotPeAHoj: 0 });
      this.setState({ aParPaVePe: response.data[9] });
      this.setState({ aTotPaVePe: response.data[10] });
      this.setState({ aPenDatFut: response.data[11] });
      this.setState({ aTotPeDFut: response.data[12] });

//      console.log(this.state.aPenMesAnt);
//      console.log(this.state.aPenMesAnt.length);
//      console.log(this.props.cPMA);
//      console.log(this.props);
    })
    .catch(function (error) {console.log(error); alert(error)})
  }

  render() {
    // console.log(this.state.aVendasCli.shift());
//    console.log(this.props);
    return (
      <>
        <CabPage  titulo="Relatório de Fechamento" 
                  subtitulo={"Período das vendas: " + FormataData(this.props.dIni) + " - " + FormataData(this.props.dFim)}
                  paginavoltar="/venrfe" 
                  classSubTit="SubTitRel" />
        {this.state.aVendasCli.length === 0 && 
          <Alert variant="warning">Não há vendas para listar !</Alert>
        }
        {this.state.aVendasCli.length > 0 && this.props.cTCl === "S" && 
          <>
            <b>Total das vendas do período (pagas ou em aberto) </b>
            <Table striped bordered hover>
              <thead>
                <tr key={100}>
                  <th width="50%">Cliente</th>
                  <th width="50%">$Total</th>
                </tr>
              </thead>
              <tbody>
              {
                this.state.aVendasCli.map((oVenda, index) => (
                  <>
                    <tr key={3000+index}>
                      <td>{oVenda.fantasia} ({oVenda.id_cliente})</td>
                      <td align='right'>{FormataValor(parseFloat(oVenda.ValVen))}</td>
                    </tr>
                  </>
              ))}
              </tbody>
            </Table>
          </>
        }
        {/* parte abaixo a partir de 17/09/25 */
          this.state.aVendasCli.length > 0 && this.props.cTDP === "S" && 
          <>
            <b>Total por por dia e produto (pagas ou em aberto)</b>
            <Table striped bordered hover>
              <TopTabRelVen k={700} />
              <tbody>
              {
                  this.state.aVendasDPU.map((oVenda, index) => (
                  <>
                    <tr key={2000+index}>
                      <td>{FormataData(oVenda.data_venda)}</td>
                      <td>{oVenda.desc_produto}</td>
                      <td>{oVenda.desc_unidade}</td>
                      <td align='right'>{FormataValor(parseFloat(oVenda.QtdVen))}<br/>
                                        {FormataValor(parseFloat(oVenda.QtdBon))}</td>
                      <td align='right'>{FormataValor(parseFloat(oVenda.ValVen / oVenda.QtdVen))}</td>
                      <td align='right'>{FormataValor(parseFloat(oVenda.ValVen))}</td>
                    </tr>
                  </>
              ))}
              </tbody>
            </Table>
          </>
        }
        <Separador />
        <br/>
        {this.state.aParPaVePe.length > 0 &&
          <>
            <b>Parcelas pagas das vendas do período</b>
            <Table striped bordered hover>
              <thead>
                <tr key={250}>
                  <th width="50%">Vencimento</th>
                  <th width="50%">$Total</th>
                </tr>
              </thead>
              <tbody>
              {
                this.state.aParPaVePe.map((oVenda, index) => (
                  <>
                    <tr key={(index+60000)}>
                      <td>{FormataData(oVenda.data_vencim)}</td>
                      <td align='right'>{FormataValor(parseFloat(oVenda.valor))}</td>
                    </tr>
                  </>
              ))}
              </tbody>
            </Table>
            <b>Total: {FormataValor(parseFloat(this.state.aTotPaVePe[0]))}</b>
            <br/><br/>
            </>
        }
        {this.state.aPenAteHoj.length > 0 && this.props.cPMA === "S" &&
          <>
            <Separador />
            <br/>
            <b>Parcelas em aberto até a data de hoje</b>
            <Table striped bordered hover>
              <thead>
                <tr key={250}>
                  <th width="50%">Vencimento</th>
                  <th width="50%">$Total</th>
                </tr>
              </thead>
              <tbody>
              {
                this.state.aPenAteHoj.map((oVenda, index) => (
                  <>
                    <tr key={(index+60000)}>
                      <td>{FormataData(oVenda.data_vencim)}</td>
                      <td align='right'>{FormataValor(parseFloat(oVenda.valor))}</td>
                    </tr>
                  </>
              ))}
              </tbody>
            </Table>
            <b>Total: {FormataValor(parseFloat(this.state.aTotPeAHoj[0]))}</b>
            <br/><br/>
            </>
        }
        <Separador />
        <br/>
        {this.state.aPenDatFut.length > 0 && 
          <>
            <b>Parcelas futuras em aberto</b>
            <Table striped bordered hover>
              <thead>
                <tr key={250}>
                  <th width="50%">Vencimento</th>
                  <th width="50%">$Total</th>
                </tr>
              </thead>
              <tbody>
              {
                this.state.aPenDatFut.map((oVenda, index) => (
                  <>
                    <tr key={(index+60000)}>
                      <td>{FormataData(oVenda.data_vencim)}</td>
                      <td align='right'>{FormataValor(parseFloat(oVenda.valor))}</td>
                    </tr>
                  </>
              ))}
              </tbody>
            </Table>
            <b>Total: {FormataValor(parseFloat(this.state.aTotPeDFut[0]))}</b>
            <br/><br/>
            </>
        }
        { 
        <>
        <Separador />
        <b>Total em aberto (considerando o que foi listado): {FormataValor(parseFloat(
            (isNaN(this.state.aTotPeDFut[0]) ? 0 : this.state.aTotPeDFut[0]) + (isNaN(this.state.aTotPeAHoj[0]) ? 0 : this.state.aTotPeAHoj[0])))}</b>
        <Separador />
        </>
        }
      </>
    );
  }
}

export default VendasRelFechRes;